<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { LazyMarkdown } from '../../../../components/LazyMarkdown';
	import { TxtVariantsMap } from '../../../../components/Txt';
	import type { ArticleChartType } from '../../types';

	interface Props {
		item: NonNullable<ArticleChartType>;
		getImageUrl: (path: string | null | undefined) => void;
		onclick: ((image: ArticleChartType) => void) | undefined;
	}

	let { item, getImageUrl, onclick }: Props = $props();

	let handleClickImage = $derived(() => {
		if (onclick) {
			onclick(item);
		}
	});
</script>

{#if item}
	<!-- The chart image's alt is its legend, which is often empty, so the
	button needs its own name. -->
	<button
		onclick={handleClickImage}
		aria-label="View chart full size"
		class="bg-gray-75 flex aspect-video w-full items-center justify-center"
	>
		<img
			src={`${getImageUrl(item.image?.filename_disk)}`}
			alt={item.legend}
			data-cy="article-chart"
			class="max-h-full max-w-full"
		/>
	</button>
	{#if item.legend}
		<LazyMarkdown
			dataCy="article-chart-legend"
			class={twMerge(
				TxtVariantsMap.label4,
				'mt-1 [&>p>span]:text-[0.75rem] [&>p>span]:leading-[1rem] [&>p>span]:text-gray-500 [&>p]:text-[0.75rem] [&>p]:leading-[1rem] [&>p]:text-gray-500'
			)}
			source={item.legendTokens ?? item.legend}
		/>
	{/if}
{/if}
